<template>
    <div class="mainContainer">
        <CustomHeader :text="$t('bonus.mysterybonus')" bgColor="#002d2d" />:

       <div class="page_main_title"> {{ $t('bonus.pageTitle') }}</div>

        <div class="amount_wrapper">
            <div :class="['topamount', { 'is-transparent': !(dataSet.selectedTab?.reward_data?.activeStatus === 0 || (dataSet.selectedTab?.reward_data?.activeStatus === 1 && dataSet.selectedTab?.reward_data?.rewardCoin)) }]">
                <span class="currency-badge">R$</span>
                {{ formatCurrency(dataSet.selectedTab?.reward_data?.rewardCoin || 0) }}
            </div>
        </div>

       <div class="mystery_visual_wrapper">
            <img src="@/assets/themeFour/circleBot.png" class="layer base_plate" />

            <img src="@/assets/themeFour/maskBox.png" class="layer mystery_chest" />

            <img src="@/assets/themeFour/circle.png" class="layer glass_dome" />

            <img src="@/assets/themeFour/pandaImg.png" class="layer panda_character" />
        </div>


        <!-- <div class="bonus_container"> -->
            <!-- <img :src="dataSet.bannerIcon" alt=""> -->

            <div class="buttonFooter inline_button">
            <van-row>
                <!-- Expired -->
                <van-col
                    v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0 && !dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="start_img">
                    <van-icon name="checked" color="#66d329" size="18px" style="margin-right: 8px;" />
                    {{ $t('activityStatus.expired') }}
                </van-col>
                <!-- Previous claimed -->
                <van-col
                    v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0 && dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="statusBar" style="color:#66d329">
                    {{ $t('activityStatus.completed') }}
                </van-col>
                <!-- Today not claimed -->
                <van-col
                    v-if="dataSet.selectedTab?.reward_data?.activeStatus === 1 && !dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="start_img2">
                    <img src="@/assets/bonus/smactv2_btn_notstart.png" alt=""
                        :class="{ 'pop-animate': dataSet.isPopping }"
                        @click="pickMisteryGift(dataSet.selectedTab?.reward_data?.activeStatus)"></van-col>

                <!-- Today claimed -->
                <van-col
                    v-if="dataSet.selectedTab?.reward_data?.activeStatus === 1 && dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="statusBar" style="color:#66d329">
                    {{ $t('activityStatus.completed') }}
                </van-col>
                <!-- Upcoming -->
                <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 2" span="24" class="statusBar"
                    style="color:black">
                    {{ $t('rewards.notActivated') }}
                </van-col>
            </van-row>
        </div>
        <div class="day_row">
            <BonusTracker 
                :dayList="dataSet.dayList" 
                :activeDay="dataSet.selectedTab?.reward_day" 
                @select="selectTab" 
            />
        </div>

        <div style="padding: 0 15px 15px;">
            <div class="details_card" v-if="dataSet.selectedTab">
                
                <van-row class="details_content">
                   <van-col span="24">
                        <van-row class="middleCard">
                            <van-col span="24" class="text_1">
                                {{ $t('bonus.claimTime') }}
                            </van-col>
                            <van-col span="24">
                                <div class="date_details">
                                    <!-- <img src="@/assets/bonus/smactv2_clock.png" alt=""> -->
                                    {{ formatUnixTimestamp(dataSet.selectedTab?.reward_data?.rewardTime) }}
                                </div>
                           </van-col>
                           <van-col span="24" class="combined_amount_row">
                            <div class="amount_wrapper" style="min-height: 80px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                
                            <div class="amount">

                                        <div
                                            v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0 || (dataSet.selectedTab?.reward_data?.activeStatus === 1 && dataSet.selectedTab?.reward_data?.rewardCoin)">
                                            <span class="currency-badge">R$</span>
                                            {{ formatCurrency(dataSet.selectedTab?.reward_data?.rewardCoin || 0) }}
                                        </div>
                                        <div v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0"
                                            class="misterio_text">
                                            {{ $t('bonus.mysterybonus') }}
                                        </div>
                                        <div
                                            v-if="dataSet.selectedTab?.reward_data?.activeStatus === 2 || (dataSet.selectedTab?.reward_data?.activeStatus === 1 && !dataSet.selectedTab?.reward_data?.rewardCoin)"
                                            class="misterio" style="margin-top: 0;">
                                            <!-- <img src="@/assets/bonus/weikaishi_tu.png" alt=""> -->
                                            {{ $t('rewards.notActivated') }}
                                        </div>
                                    </div>
  
                            </div>
                            </van-col>
                        </van-row>
                    </van-col>
                </van-row>
               <div class="middleCardTop">
                    <div class="middleTop">
                        <van-row class="info_row">
                            <van-col span="2" class="icon_col">
                                <van-icon name="clock-o" />

                                <!-- <van-col span="2"> -->
                            </van-col>
                            <van-col span="12" class="label_text">{{ $t('bonus.registrationTime') }}</van-col>
                            <van-col span="10" class="value_text" style="font-weight: 500;">{{
                                formatUnixTimestamp(dataSet.mysteryDataConfig?.config?.user_join_date)
                                }}</van-col>
                        </van-row>
                        <van-row class="info_row">
                            <van-col span="2" class="icon_col">
                               <van-icon name="points" />
                                <!-- <van-col span="2"> -->
                            </van-col>
                            <van-col span="13" class="label_text">{{ $t('bonus.totalDeposit') }}
                                {{ dataSet.selectedTab?.reward_day }}{{ $t('common.days') }}:</van-col>
                            <van-col span="9" class="value_text" style="font-weight: 500;">R${{
                                formatCurrency(dataSet.selectedTab?.reward_data?.rechargeCoin
                                    || 0)
                                }}
                            </van-col>
                        </van-row>
                    </div>
                </div>

            </div>
        </div>

        </div>

        <!-- .................... -->

        <div class="tabel_container" v-if="dataSet.selectedTab">
            <van-row class="tabel_hed">
                <van-col span="12" class="head_alignemnet">{{ $t('bonus.depostiScope') }}</van-col>
                <van-col span="12" class="head_alignemnet">{{ $t('bonus.mysteryPrize') }}</van-col>
            </van-row>
            <van-row class="tabel_row" v-for="(item, index) in dataSet.selectedTab?.reward_data?.reward_day_data"
                :key="index">
                <van-col span="12" class="head_alignemnet">R$
                    <span>{{ item.recharge_min < 0 ? '\u221E' : formatCurrency(calculateValue(item.recharge_min)) }} ~
                            {{ item.recharge_max < 0 ? '\u221E' : formatCurrency(calculateValue(item.recharge_max)) }}
                            </span>
                </van-col>
                <van-col span= "12" class="head_alignemnet currencyText" ><span class="currency-prefix">R$</span>
                    <span>{{ item.show_reward_min < 0 ? '\u221E' :
                        formatCurrency(calculateValue(item.show_reward_min)) }} ~ {{ item.show_reward_max < 0
                                ? '\u221E' : formatCurrency(calculateValue(item.show_reward_max)) }} </span></van-col>
            </van-row>
        </div>

        <!-- ........................... -->


        <div class="bottom_text" v-if="dataSet.activityInfo.length > 0">
            <van-row style="padding-bottom: 10px;">
                <van-col span="24" class="title">
                    <div class="ruleHeader">
                    <img class="side-icon" src="@/assets/themeFour/tittleIcon.png" />
                    <div class="tittle">{{ $t('common.eventRule') }}</div>
                    <img class="side-icon flipped" src="@/assets/themeFour/tittleIcon.png" />
                    </div>
                </van-col>
            </van-row>
            <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
                {{ item }}
            </div>
        </div>

</template>
<script setup lang="ts">
import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';
import { ref } from 'vue';
import { BonusData, calculateValue, MYSTERIO_IMG_THREE } from '@/view/bonus/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import BonusTracker from './BonusTracker.vue';
import { useRouter } from 'vue-router';

const mysterioImages = ref(MYSTERIO_IMG_THREE)
const router = useRouter()
const props = defineProps<{
    dataSet: BonusData
}>()

const emits = defineEmits(['pickMisteryGift', 'selectTab'])

const pickMisteryGift = (activeStatus: number) => {
    emits('pickMisteryGift', activeStatus)
}

const selectTab = (item: any) => {
    emits('selectTab', item)
}


</script>
<style scoped>

.mainContainer {
    padding-top: 60px; 
    background-image: url('@/assets/themeFour/backgroundMistry.png') !important;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center -80px;
    /* min-height: 100vh; */
}

.page_main_title {
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 5px;
    min-height: 40px;
}

.mystery_visual_wrapper {
    position: relative;
    width: 100%;
    max-width: 400px; 
    aspect-ratio: 1.3;
    margin: -13% auto -10% auto;
}

.layer {
    position: absolute;
    height: auto;
}

.base_plate {
    width: 78%;
    bottom: 3%;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
}

.mystery_chest {
    width: 57%;
    bottom: 16%;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
    animation: chestHover 3s ease-in-out infinite;
}

.glass_dome {
    width: 68%;
    bottom: 14%;
    z-index: 3;
    opacity: 0.9; 
    left: 50%;
    transform: translateX(-50%);
}

.panda_character {
    width: 23%;
    right: -7%;
    bottom: 0%;
}

.top_amount_display {
    background: linear-gradient(90deg,rgba(255,255,255,.03) 2.09%,rgba(255,255,255,.3),rgba(255,255,255,.03) 99.07%);
    padding: 0 2.5rem;
}

.buttonFooter.inline_button {
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative; 
    bottom: auto;     
    background: transparent; 
    box-shadow: none;  
    z-index: 2;
    margin-bottom: 0px;  
}

.currency-prefix{
    color: #FBA531;
    font-weight: 600;
    font-size: 14px;
}

.info_row {
    display: flex;
    align-items: center;
}

.combined_amount_row {
    padding: 5px 0;
   
}
.amount {
    display: flex;
    color: #f5c84c;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 35px;
    padding-top: 10px;
}

.topamount{
  display: inline-flex; 
  align-items: center;
  justify-content: center;
  color: var(--ep-color-text-highlight, #F5C84C);
  font-size: 1.5rem;
  font-weight: bold;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.03) 2.09%,
    rgba(255, 255, 255, 0.3) 50%, 
    rgba(255, 255, 255, 0.03) 99.07%
  );
  padding: 5px 2.5rem; 
  max-width: 90%; 
  margin: 0 auto;
  gap: 20px;
  margin-top: 5px;
}

.is-transparent {
    opacity: 0;
    pointer-events: none;
}

.amount_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 40px;
    padding-top: 15px;
}

.bottom_text {
    padding: 24px;
    max-width: 500px;
    margin: 16px  0 0;
    background-color: transparent;
    padding-bottom: 120px !important;
}
.ruleHeader {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 10px;
    position: relative;
    z-index: 10;
}
.side-icon {
    width: 45px;
    height: auto;
    display: block;
}

.flipped {
    transform: scaleX(-1);
}

.bonus_container {
    padding: 45px 0 0;
    position: relative;
}

.day_row {
    padding: 0 15px;
    margin-top: 0px;
    display: flex;
    flex-direction: row;
}

.bonus_container img {
    width: 100%;
}

.arrowIcon {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
}

.date_text {
    font-size: 13px;
    color: #937f9a;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    margin-top: 5px;
    font-weight: 600;
}

.date_text span {
    padding-left: 5px;
}

.select_icon {
    display: flex;
    justify-content: center;
}

.select_icon img {
    width: 18px;
    padding-top: 10px;
}

.tab_arrow {
    display: flex;
    justify-content: center;
}

.tab_arrow img {
    width: 25px;
}


.currencyText {
    color: #FBA531;
    font-weight: 800;
}
.currencyText span {
  color: #FBA531; 
  font-weight: 800;
  font-size: 15px;
}


.label_text {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.65); 
}

.label_text span {
    color: #FFEE00;
    padding: 0 5px;
}

.value_text {
    display: flex;
    align-items: center;
    justify-content: right;

}

.text_1 {
    color: rgba(255, 255, 255, 0.65);
    font-size: 15px;
    display: flex;
    justify-content: center;
    text-align: center;
}

.middleTop {
    width: 100%;
    display: contents;
    font-size: 14px;
    color: #fff;
    line-height: 30px;

}

.middleCard {
    border-radius: 10px;
    background-image: url("@/assets/themeFour/middleCard.png");
    background-size: 100% 100%;       
    background-position: 40% center;      
    background-repeat: no-repeat;
    padding: 20px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.middleCardTop {
    width: 95%;
    border-radius: .9375rem;
    padding: 5px 0;
    background: #005655;
    margin: .75rem auto;
    height: 5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding-left: 10px;
    padding-right: 10px;
    
}
.date_details {
    color: #ffffff;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}

.date_details img {
    width: 20px;
    padding: 5px;
}
.misterio_text {
  background: #fff;
  color: #131f42;
  padding: 4px 8px;
  font-weight: 600;
  display: inline-block;
  font-size: 16px;
  text-align: center;
  margin-top: 10%;
}

.amount span {
    font-size: 20px;
    padding: 0 5px;
    color: #f5c84c;
    font-weight: bold;
    display: inline-block;

}

.start_img {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    background: #7887b1;
    padding: 10px;
    border-radius: 50px;
    margin: 15px auto 10px;
    width: 250px;
    box-sizing: border-box;
    color: white;
}

.start_img2 {
    display: flex;
    align-items: center;
    justify-content: center;
}

.start_img2 img {
    width: 310px;
}

.misterio {
    display: flex;
    color: #f5c84c;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 30px;
    padding: 25px 0;

}

.tabel_container {
    border-radius: 10px;
    margin: 0 15px;
    overflow: hidden;
}

.tabel_hed {
    background-color: #005655;
    padding: 15px;
    font-size: 16px; 
    font-weight: bold;
}

.row_striped {
    background-color: transparent !important;
}

.tabel_row:nth-child(odd) {
  background-color: #005655; 
}
.tabel_row:nth-child(even) {
  background-color: transparent; 
}

.head_alignemnet {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: rgba(255, 255, 255, 0.65);
}

.line {
    width: 1px;
    height: 15px;
    background-color: rgba(255, 255, 255, 0.15);
}

.tabel_row {
    display: flex;
    align-items: center;
    color: #FFFFFF;
    padding: 10px 0;
}
.last_row {
    border-radius: 0 0 8px 8px;
}

.tabel_row .van-col:first-child {
    color: #FFFFFF !important;
    font-weight: 500;
}

.tabel_row span {
    padding: 0 5px;
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: #ffffff;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    white-space: nowrap;
}

.line_text {
    color: #ffffff99;
    font-size: 16px;
    padding: 10px;
    line-height: 1.5;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

.statusBar {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    background: #FBBF31;
    padding: 10px;
    border-radius: 50px;
    margin: 15px auto 10px;
    width: 250px;
    box-sizing: border-box;
    color: black;
    border: 2px solid #fb8e00;
}

@media (min-width: 450px) {
    .statusBar {
        width: 270px;
        max-width: 225px;
    }
    .middleTop{
            font-size: 3.8vw;
    }
}


@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}

@media(min-width: 450px) {

    .middleCard {
        font-size: 20px
    }

    .middleTop {
        font-size: 17px;
    }

}

@media (max-width: 360px) {
    .page_main_title {
        font-size: 26px;
        margin-bottom: 10px;
    }
    .mystery_visual_wrapper {
        margin-top: -60px;
        margin-bottom: -30px;
    }
    .panda_character {
        bottom: -15%;
        right: -1%;
    }
    .topamount {
        font-size: 1rem;
        padding: 5px 1rem;
        gap: 10px;
    }
    .start_img {
        width: 50vw;
        font-size: 12px;
    }
    .start_img img {
        width: 60vw;
    }
    .middleCardTop {
        height: auto;
        padding: 10px 5px;
    }
    .label_text, .value_text {
        font-size: 12px;
        line-height: 1.2;
    }
    .tabel_hed {
        font-size: 13px;
        padding: 10px 5px;
    }
    .tabel_row, .currencyText span {
        font-size: 12px;
    }
    .line_text {
        font-size: 14px;
    }
    .title {
        font-size: 16px;
    }
    .amount span {
        font-size: 18px;
    }
    .misterio_text {
        font-size: 13px;
    }
    .misterio {
        font-size: 13px;
    }
    .statusBar {
        font-size:12px;
        width: 50vw;
    }   
}
</style>